import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  addressLabel: {
    id: 'map.addressLabel',
    defaultMessage: 'Osoite',
  },
  cityLabel: {
    id: 'map.cityLabel',
    defaultMessage: 'Kaupunki',
  },
  clearLabel: {
    id: 'map.clearLabel',
    defaultMessage: 'Tyhjennä',
  },
  saveLabel: {
    id: 'map.saveLabel',
    defaultMessage: 'Tallenna',
  },
})
